import { render } from "./CIS-Controls-Resources-Listing.vue?vue&type=template&id=29bc1a09&scoped=true"
import script from "./CIS-Controls-Resources-Listing.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Resources-Listing.vue?vue&type=script&lang=js"

import "./CIS-Controls-Resources-Listing.vue?vue&type=style&index=0&id=29bc1a09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bc1a09"]])

export default __exports__